import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import TreePanel from './components/organisms/trees/GeofencesTree';
import { JssProvider } from 'react-jss'; // требует типы, но пока при сборке с ними падает.
import { create } from 'jss';
import { FMMapContainer } from 'features/FMMap';
import { FMDevicesInfoPage } from 'features/FMDevicesInfo';
import { MuiThemeProvider, createGenerateClassName, jssPreset } from '@material-ui/core/styles';

import theme from './theme/theme';
import { Store } from 'redux';

window.localStorage.removeItem('checkedGeozonesIds');

const jss = create({
    ...jssPreset(),
    // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
    insertionPoint: document.getElementById('jss-insertion-point'),
});

interface GeofenceEditPanelOptions {
    fortMap: any;
}

export default class FMComponentsRenderer {
    fmStore: Store;
    public fortMap: any;

    constructor(options: GeofenceEditPanelOptions) {
        if (options) {
            this.fortMap = options.fortMap;
            this.fmStore = store(options.fortMap);
        }
    }

    public renderGeofenceEditPanel = (targetInDOM: string): void => {
        ReactDOM.render(
            <Provider store={this.fmStore}>
                <JssProvider jss={jss} generateClassName={createGenerateClassName()}>
                    <MuiThemeProvider theme={theme}>
                        <React.Fragment>
                            <TreePanel />
                        </React.Fragment>
                    </MuiThemeProvider>
                </JssProvider>
            </Provider>,
            document.getElementById(targetInDOM),
        );
    };

    public renderFMMapContainer = (targetInDOM: string): void => {
        ReactDOM.render(
            <Provider store={this.fmStore}>
                <FMMapContainer fortMap={this.fortMap} />
            </Provider>,
            document.getElementById(targetInDOM),
        );
    };

    public renderDevicesInfoPage = (targetIdInDOM: string): void => {
        ReactDOM.render(
            <JssProvider jss={jss} generateClassName={createGenerateClassName()}>
                <MuiThemeProvider theme={theme}>
                    <FMDevicesInfoPage />
                </MuiThemeProvider>
            </JssProvider>,
            document.getElementById(targetIdInDOM),
        );
    };
}
